<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t("common.wddd") }}</div>
      <!-- 订单表格 -->
      <el-table :data="tableData"
                style="width: 100%;"
                @row-click="handle"
                v-loading="loading"
                :cell-style="rowClassName"
                :header-cell-style="headerClassName"
      >
        <el-table-column prop="orderCode" :label="$t('common.cds82')" width="180"/>
        <el-table-column prop="productName" :label="$t('common.cds83')">
          <template #default="{row}">
            <template v-if="row.productType&&row.productType<=4">
              {{ $t(`userinfo.vip.service.${row.productType}`) }}
            </template>
            <template v-else-if="row.productType&&row.productType>4">
              {{ $t(`vip.type.${row.productType - 5}`) }}
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" :label="$t('common.cds84')" width="180"/>
        <el-table-column prop="totalMoney" :label="$t('common.amount.realpay')" width="180">
          <template #default="{ row, column, $index }">
            <span style="font-size: 14px">￥</span>
            <span style="font-size: 14px">
              <span v-if="row.totalMoney !== null && Object.keys(row).length > 0">
                <span style="font-size: 14px">{{ row.totalMoney.toFixed(2).split('.')[0] }}</span>.
                <span>{{ row.totalMoney.toFixed(2).split('.')[1] }}</span>
              </span>
             <span v-else>
               {{ row.totalMoney }}
             </span>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
            size="small"
            v-model:current-page="current"
            v-model:page-size="size"
            v-if="total"
            layout="total, prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import BasicCard from "./Basic/BasicCard.vue";
import {reactive, ref, onMounted} from "vue";
import {useRouter} from "vue-router";
import {getQueryMyOrder} from "@/api/usercenter";
import {ElTable} from "element-plus";

const router = useRouter()
const tableData = ref([]);
const loading = ref(false);
const current = ref(1);
const size = ref(10);
const total = ref(0);
const handleCurrentChange = (page) => {
  current.value = page;
  getQueryMyOrderApis();
};


// 获取所有的订单数据
const getQueryMyOrderApis = async () => {
  loading.value = true;
  let res = await getQueryMyOrder(
      {
        pageNo: current.value,
        pageSize: size.value
      }
  )
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  const {records} = res.result;
  loading.value = false;
  tableData.value = records;
  current.value = res.result.current;
  total.value = res.result.total;
  size.value = res.result.size;
}

const handle = (row) => {
  const {orderCode, id} = row
  router.push({path: '/personal/orderDetails', query: {payCode: orderCode}})
}

onMounted(async () => {
  await getQueryMyOrderApis();
})

const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;


  .right {
    //overflow: auto !important;
    padding-bottom: 40px !important;
    height: auto !important;
    max-width: 1200px !important;
    min-height: 640px !important;
  }
}


:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}
</style>
